



















import Vue from "vue"

export default Vue.extend({
  name: "PinInput",

  props: {
    value: {
      type: String,
      default: ""
    },
    length: {
      type: Number,
      default: 4
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      values: [] as string[]
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val: string) {
        this.values = Array.from({ length: this.length }).map(
          (_, i) => (val && val[i]) || ""
        )
      }
    },
    values: {
      deep: true,
      handler() {
        this.$emit("input", this.values.join(""))
      }
    }
  },

  methods: {
    focus(index: number) {
      const refs = this.$refs.inputs as any
      if (refs && refs[index]) {
        refs[index].focus()
      }
    },

    onInput(index: number, val: string) {
      if (!/^[0-9]?$/.test(val)) {
        this.$set(this.values, index, "")
        return
      }

      if (val && index < this.length - 1) {
        this.focus(index + 1)
      }
      this.checkComplete()
    },

    onKeydown(index: number, e: any) {
      if (e.key === "Backspace" && !this.values[index] && index > 0) {
        this.focus(index - 1)
      }
    },

    onPaste(e: any) {
      const pasted = e.clipboardData.getData("text") || ""
      if (!/^\d+$/.test(pasted)) {
        return
      }

      pasted
        .slice(0, this.length)
        .split("")
        .forEach((char, i) => {
          this.$set(this.values, i, char)
        })

      this.checkComplete()
    },
    checkComplete() {
      const pin = this.values.join("")
      if (pin.length === this.length) {
        this.$emit("complete", pin)
      }
    }
  }
})
